/* eslint no-undef: "off"*/
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('froala-editor')) :
        typeof define === 'function' && define.amd ? define(['froala-editor'], factory) :
            (factory(global.FroalaEditor));
}(this, (function (FE) { 'use strict';

    FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

    Object.assign(FE.POPUP_TEMPLATES, {
        'drawio.edit': '[_BUTTONS_]'
    }); // Extend defaults.

    Object.assign(FE.DEFAULTS, {
        diagramEditButtons: ['drawioOpen', 'drawioEdit', 'drawioRemove'],
        wordDeniedTags: [],
        wordDeniedAttrs: [],
        wordAllowedStyleProps: ['font-family', 'font-size', 'background', 'color', 'width', 'text-align', 'vertical-align', 'background-color', 'padding', 'margin', 'height', 'margin-top', 'margin-left', 'margin-right', 'margin-bottom', 'text-decoration', 'font-weight', 'font-style', 'text-indent', 'border', 'border-.*', 'line-height', 'list-style-type'],
        wordPasteModal: true,
        wordPasteKeepFormatting: true
    });

    FE.PLUGINS.drawio = function (editor) {
        var $ = editor.$;
        var $modal;
        var modal_id = 'drawio';
        var clipboard_html;
        var _v_shapes_map = {};
        let destroyed = false;
        /*
         * Init Word Paste.
         */

        function _init() {
            destroyed = false;
            // console.log("init");
            // we couldn't get load event of iframes, therefore we pushing messages several in a time

            bindEvent(window, 'message', function (e) {
                if(e.data !== undefined && e.data !== null) {
                    //console.log(e.data);
                    try {
                        var json = JSON.parse(e.data);
                        if (json.hasOwnProperty("type")) {
                           if(json.type === "graphMouseEnter") {
                               // console.log(json.type);
                           } else if(json.type === "graphMouseLeave") {
                               // console.log(json.type);
                               // console.log(e);
                           } else if(json.type === "graphMouseUp") {
                               let href = json.location.href;
                               var url = new URL(href);
                               let apID = url.searchParams.get("_apID");

                               if(apID !== null && apID !== undefined) {
                                   editor.currentIframe = document.querySelector("iframe:not(#drawio-iframe)[src*='_apID="+apID+"']");
                               } else if(!editor.currentIframe) {
                                   editor.currentIframe = document.querySelector("iframe:not(#drawio-iframe)[src*='"+href+"']");
                               }
                               //editor.selection.setBefore(editor.currentIframe);
                               // editor.focus();
                               editor.selection.setBefore(editor.currentIframe) || editor.selection.setAfter(editor.currentIframe);
                               editor.selection.restore();
                               _edit(json.event, true);
                           }
                        }
                    }
                    catch(e)
                    {
                        // do nothing
                    }
                }
            });

            editor.events.on('window.mouseup', _edit); // Do not follow links when edit is disabled.
            editor.events.on('destroy', function() {
                destroyed = true;
            });

            let eventsBinded = [];
            let f = function(){
                editor.$el.find("iframe").each( function(index) {
                    this.contentWindow.postMessage("loaded from froala", "*");
                    if(!eventsBinded.includes(this)) {
                        // console.log("binmd");
                        bindEvent(this, 'mouseover', function (e) {
                            // console.log("mouse_over");
                            //console.log(e.target);
                            // e.target.style.cursor("pointer");
                            // send message to change cursor to pointer
                            editor.currentIframe = e.target;
                        });
                        bindEvent(this, 'mouseout', function (e) {
                            // console.log("mouse_out");
                            // e.target.style.cursor("default");
                            // send message to change cursor to default
                            //editor.currentIframe = null;
                        });
                        eventsBinded.push(this);
                    }
                });
            };
            setTimeout(f, 1000);
            setTimeout(f, 3000);
            setTimeout(f, 5000);
            setTimeout(f, 8000);
            setTimeout(f, 12000);
            setTimeout(f, 20000);
            setTimeout(f, 30000);


        }
        /*
         * Build html body.
         */

        function get(apID = null) {
            if(apID !== null && apID !== undefined) {
                let fr = document.querySelector("iframe:not(#drawio-iframe)[src*='_apID="+apID+"']");
                if(fr !== null && fr !== undefined) return fr;
            }
            if(editor.currentIframe) {
                // console.log("currentIframe");
                return editor.currentIframe;
            }
            if (editor.$wp) {
                // console.log("wp");
                var c_el = editor.selection.ranges(0).commonAncestorContainer;
                // console.log(c_el);

                try {
                    if (c_el && (c_el.contains && c_el.contains(editor.el) || !editor.el.contains(c_el) || editor.el === c_el)) c_el = null;
                } catch (ex) {
                    c_el = null;
                }

                if (c_el && c_el.tagName === 'iframe') return c_el;
                var s_el = editor.selection.element();
                var e_el = editor.selection.endElement();

                // console.log(s_el);
                // console.log(e_el);

                if (s_el.tagName !== 'iframe' && !editor.node.isElement(s_el)) {
                    s_el = $(s_el).parentsUntil(editor.$el, 'iframe').first().get(0);
                }

                if (e_el.tagName !== 'iframe' && !editor.node.isElement(e_el)) {
                    e_el = $(e_el).parentsUntil(editor.$el, 'iframe').first().get(0);
                }

                try {
                    if (e_el && (e_el.contains && e_el.contains(editor.el) || !editor.el.contains(e_el) || editor.el == e_el)) e_el = null;
                } catch (ex) {
                    e_el = null;
                }

                try {
                    if (s_el && (s_el.contains && s_el.contains(editor.el) || !editor.el.contains(s_el) || editor.el == s_el)) s_el = null;
                } catch (ex) {
                    s_el = null;
                }

                if (e_el && e_el == s_el && e_el.tagName == 'iframe') {
                    // We do not clicking at the end / input of links because in IE the selection is changing shortly after mouseup.
                    // https://jsfiddle.net/jredzam3/
                    if ((editor.browser.msie || editor.helpers.isMobile()) && (editor.selection.info(s_el).atEnd || editor.selection.info(s_el).atStart)) {
                        return null;
                    }

                    return s_el;
                }

                return null;
            } else if (editor.el.tagName === 'iframe') {
                // console.log("el iframe");
                return editor.el;
            }
            // console.log("not");

            return null;
        }

        function _edit(e, isIframeForwarded = false) {
            if(destroyed) return;
             // console.log("clicked");
            if (editor.core.hasFocus() || isIframeForwarded) {
                // console.log("focus or iframe")
                // _hideEditPopup(); // Do not show edit popup for link when ALT is hit.

                if (e && e.type === 'keyup' && (e.altKey || e.which == FE.KEYCODE.ALT)) return true;
                setTimeout(function () {
                    // No event passed.
                    // Event passed and (left click or other event type).
                    if (!e || e && (e.which == 1 || e.type != 'mouseup')) {
                        var link = get();
                        // console.log(link);
                        // if (e) {
                        //     e.stopPropagation();
                        // }
                        if(isIframeForwarded)
                            _showEditPopup(link);
                        else
                            _hideEditPopup();
                    }
                }, editor.helpers.isIOS() ? 100 : 0);
            }
        }

        function _showEditPopup(diagram) {
            var $popup = editor.popups.get('drawio.edit');
            if (!$popup) $popup = _initEditPopup();
            var $diagram = $(diagram);

            if (!editor.popups.isVisible('drawio.edit')) {
                editor.popups.refresh('drawio.edit');
            }

            editor.popups.setContainer('drawio.edit', editor.$sc);
            //console.log($diagram.offset().left);
            //console.log($diagram.offset().top);
            //console.log($diagram.outerWidth());
            //console.log($diagram.outerHeight());
            var left = $diagram.offset().left + $diagram.outerWidth() / 2;
            var top = $diagram.offset().top + $diagram.outerHeight();
            editor.popups.show('drawio.edit', left, top, $diagram.outerHeight(), true);
            //editor.popups.show('text.edit', editor.$el.offset().left + editor.$el.outerWidth() / 2, editor.$el.offset().top + editor.$el.outerHeight(), editor.$el.outerHeight());
        }

        function _hideEditPopup() {
            editor.popups.hide('drawio.edit');
        }

        function _initEditPopup() {
            // Link buttons.
            var diagram_buttons = '';

            if (editor.opts.diagramEditButtons.length >= 1) {
                diagram_buttons = "<div class=\"fr-buttons\">".concat(editor.button.buildList(editor.opts.diagramEditButtons), "</div>");
            }

            var template = {
                buttons: diagram_buttons // Set the template in the popup.

            };
            var $popup = editor.popups.create('drawio.edit', template);

            if (editor.$wp) {
                editor.events.$on(editor.$wp, 'scroll.diagram-edit', function () {
                    if (get() && editor.popups.isVisible('drawio.edit')) {
                        _showEditPopup(get());
                    }
                });
            }

            return $popup;
        }

        function _buildModalBody(diagramHash = null, apID = null) {
            // empty diagram for new models
            if(diagramHash === null) diagramHash = "ddHBDsIgDADQr%2BHOQOPuc%2BrF0w6eCdRBwtaFYTb9erfAnGSacCivhZJCeNGMZyc6fUUFljCqRsKPhLFsxxiZF1XPIOyQB6idUbFohcq8ICKN%2BjAK%2BqTQI1pvuhQlti1In5hwDoe07I427dqJGjZQSWG3ejPK66D5nq5%2BAVPrpXNGY6YRS3GEXguFwxfxkvDCIfoQNWMBdh7eMpdw7vQn%2B3mYg9b%2FODAF693TJvkhXr4B";
            let apAppend = "";
            if(apID !== null && apID !== undefined) {
                apAppend = "_apID="+apID+"&";
            }
            // iframe
            // Begin body.
            // var body = '<div class="fr-word-paste-modal" style="padding: 20px 20px 10px 20px;">';
            // body += '<p style="text-align: left;">' + editor.language.translate('The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?') + '</p>';
            // body += '<div style="text-align: right; margin-top: 50px;"><button class="fr-remove-word fr-command">' + editor.language.translate('Clean') + '</button> <button class="fr-keep-word fr-command">' + editor.language.translate('Keep') + '</button></div>'; // End body.
            //
            // body += '</div>';
            // return body;

            let windowHeight = document.documentElement.clientHeight;
            //let windowWidth = document.documentElement.clientWidth;
            //TODO: Zamyslet se, jak url na DrawIO dostat do pluginu z konfigu!
            let drawIOURL = "https://draw.aphinit.com";
            if (window._env_ && window._env_.APHINITFE_DRAWIO_URL) {
                drawIOURL = window._env_.APHINITFE_DRAWIO_URL;
            } else {
                console.log("Nenastaveno URL na DrawIO!");
            }
            
            let body = "<iframe id=\"drawio-iframe\" frameborder=\"0\" style=\"width:100%;height:" + ((!windowHeight || windowHeight) < 300 ? 300 : windowHeight - 200) + "px;\" src=\"" + drawIOURL +  "/?"+apAppend+"ui=min#R" + diagramHash +"\"></iframe>";
            //body += '<div style="text-align: right; margin-top: 20px;"><button class="fr-save-diagram fr-command">' + editor.language.translate('Save&Close') + '</button> <button class="fr-close-diagram fr-command">' + editor.language.translate('Close') + '</button></div>'; // End body.
            return body;
        }
        /*
         * Show modal.
         */

        function bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener){
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, eventHandler);
            }
        }

        function _showModal(diagramHash = null, apID = null) {
            // let editAction = diagramHash != null;
            // console.log("editaction" + editAction);
            if (!$modal) {
                //var head = '<h4><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.95 73.23" style="height: 25px; vertical-align: text-bottom; margin-right: 5px; display: inline-block"><defs><style>.a{fill:#2a5699;}.b{fill:#fff;}</style></defs><path class="a" d="M615.15,827.22h5.09V834c9.11.05,18.21-.09,27.32.05a2.93,2.93,0,0,1,3.29,3.25c.14,16.77,0,33.56.09,50.33-.09,1.72.17,3.63-.83,5.15-1.24.89-2.85.78-4.3.84-8.52,0-17,0-25.56,0v6.81h-5.32c-13-2.37-26-4.54-38.94-6.81q0-29.8,0-59.59c13.05-2.28,26.11-4.5,39.17-6.83Z" transform="translate(-575.97 -827.22)"/><path class="b" d="M620.24,836.59h28.1v54.49h-28.1v-6.81h22.14v-3.41H620.24v-4.26h22.14V873.2H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24V846h22.14v-3.41H620.24Zm-26.67,15c1.62-.09,3.24-.16,4.85-.25,1.13,5.75,2.29,11.49,3.52,17.21,1-5.91,2-11.8,3.06-17.7,1.7-.06,3.41-.15,5.1-.26-1.92,8.25-3.61,16.57-5.71,24.77-1.42.74-3.55,0-5.24.09-1.13-5.64-2.45-11.24-3.47-16.9-1,5.5-2.29,10.95-3.43,16.42q-2.45-.13-4.92-.3c-1.41-7.49-3.07-14.93-4.39-22.44l4.38-.18c.88,5.42,1.87,10.82,2.64,16.25,1.2-5.57,2.43-11.14,3.62-16.71Z" transform="translate(-575.97 -827.22)"/></svg> ' + editor.language.translate('Diagrams') + '</h4>';
                var head = '<h4><i class="fas fa-project-diagram"></i> ' + editor.language.translate('Diagrams') + '</h4>';
                // head += '<div style="text-align: right; margin-right: 20px;"><button class="fr-save-diagram fr-command">' + editor.language.translate('Save&Close') + '</button></div>';
                var headButton = "<button title=\"".concat(editor.language.translate('Save'), "\" class=\"fr-command fr-btn fr-save-diagram\" style=\"margin: 10px; position: absolute;\"><i class=\"fas fa-save\"></i></button>");
                head += '<div style="text-align: right; margin-right: 85px;">' + headButton + '</div>';

                var body = _buildModalBody(diagramHash, apID);

                var modalHash = editor.modals.create(modal_id, head, body);
                var $body = modalHash.$body;
                $modal = modalHash.$modal;
                $modal.find( ".fr-modal-wrapper" ).css( "width", "90%" );
                editor.events.bindClick($modal, '.fr-save-diagram', function () {
                    let iframe = document.getElementById("drawio-iframe");
                    // Send a message to the child iframe
                    // console.log("getGraphXml");
                    iframe.contentWindow.postMessage("getGraphXml", '*');

                    //inst.wordPaste.clean();
                    //_hideModal();
                });

                editor.events.$on($(editor.o_win), 'resize', function () {
                    editor.modals.resize(modal_id);
                });
                bindEvent(window, 'message', function (e) {
                    if(e.data !== undefined && e.data !== null) {
                        // console.log(e.data);
                        try {
                            var json = JSON.parse(e.data);
                            if (json.hasOwnProperty("type")) {
                                if (json.type === "getGraphXml") {
                                    let href = json.location.href;
                                    var url = new URL(href);
                                    let apID = url.searchParams.get("_apID");
                                    // console.log(apID);
                                    let fr;
                                    if(apID !== null && apID !== undefined) {
                                        fr = document.querySelector("iframe:not(#drawio-iframe)[src*='_apID="+apID+"']");
                                    } else {
                                        fr = document.querySelector("iframe:not(#drawio-iframe)[src*='"+href+"']");
                                    }
                                    // console.log(fr);
                                    let editAction = !(fr === undefined || fr === null);
                                    // console.log("editAction" + editAction);
                                    // console.log("received url> " + json.MESSAGE_URL);
                                    if (json.hasOwnProperty("IFRAME_HEIGHT") && json.IFRAME_HEIGHT > 10) {
                                        if(editAction) {
                                            update(json.MESSAGE_URL, fr, apID, json.IFRAME_HEIGHT);
                                        } else {
                                            insert(json.MESSAGE_URL, json.IFRAME_HEIGHT);
                                        }
                                    } else {
                                        if(editAction) {
                                            update(json.MESSAGE_URL, fr, apID);
                                        } else {
                                            insert(json.MESSAGE_URL);
                                        }
                                    }
                                } else if(json.type === "graphMouseEnter") {
                                    // console.log(json.type);
                                } else if(json.type === "graphMouseLeave") {
                                    // console.log(json.type);
                                }
                            }
                        }
                        catch(e)
                        {
                            // do nothing
                        }
                    }
                    // console.log("received message" +  e.data);
                    // console.log("received origin" +  e.origin);
                    // console.log(e);
                    // if (e.data !== "http://draw.aphinit.com")
                    //     return;
                    // alert(e.data);
                    // _hideModal();
                });
            } // Show modal.
            else {
                $('#drawio-iframe').replaceWith(_buildModalBody(diagramHash, apID));
            }


            editor.modals.show(modal_id); // Modal may not fit window size.

            editor.modals.resize(modal_id);
        }
        /*
         * Hide modal.
         */


        function _hideModal() {
            editor.modals.hide(modal_id);
        }

        function insert(link, height = 500) {
            // editor.edit.on(); // Focus in the editor.
            //
            // editor.events.focus(true);
            // editor.selection.restore();

            // if (editor.selection.text().length) {
            //     text = editor.selection.text();
            // } // Insert the link.

            editor.edit.on();
            editor.events.focus(true);
            editor.selection.restore();
            editor.undo.saveStep();


            // https://draw.aphinit.com?lightbox=1&highlight=0000ff&edit=_blank&layers=1&nav=1#RjZLBboQgEIafxmMTlWzcXmu362Uva5NNj1SmQgpCWKzapy%2BWYdVsmvRCZr5%2FGIYfElKq8Wip4SfNQCZ5ysaEPCd5XhR7v85gCoAUuwBaK1hA2QJq8Q0IU6S9YHDdFDqtpRNmCxvdddC4DaPW6mFb9qHl9lRDW7gDdUPlPb0I5nig%2B1268ApEy%2BPJWYqKorEYwZVTpocVIoeElFZrFyI1liBn76IvYd%2FLH%2BptMAud%2B8%2BGsj6NZ3LhlXn75Gfz%2BthV3QN2%2BaKyxwvjsG6KDliu1XvvbXwauHBQG9rMyuCf2zPulPRZ5sP7gWJ3sA7GFcIBj6AVODv5ElSjV9M2HVbOI%2BIr0yOj%2BNbtre9ihw%2FQkZguzv9qq%2B9LDj8%3D
            let url = new URL(link);
            url.searchParams.set("_apID", _uuidv4());
            link = url.toString();
            editor.html.insert('<iframe id="fr-inserted-iframe" class="fr-diagram" frameBorder="0" style="width:100%;height:' + height + 'px;" src="' + link + '"></iframe>');

            //editor.html.insert('<a href="' + link + '" target="_blank" id="fr-inserted-iframe" class="fr-diagram">' + 'bla' + '</a>'); // Get the file.

            var $iframe = editor.$el.find('#fr-inserted-iframe');
            $iframe.removeAttr('id');
            _hideModal();
            editor.undo.saveStep();


            editor.events.trigger('iframe.inserted', [$iframe]);
        }

        function update(link, iframe = null, apID = null, newHeight = null) {
            // editor.edit.on(); // Focus in the editor.
            //
            // editor.events.focus(true);
            // editor.selection.restore();

            // if (editor.selection.text().length) {
            //     text = editor.selection.text();
            // } // Insert the link.

            // https://draw.aphinit.com?lightbox=1&highlight=0000ff&edit=_blank&layers=1&nav=1#RjZLBboQgEIafxmMTlWzcXmu362Uva5NNj1SmQgpCWKzapy%2BWYdVsmvRCZr5%2FGIYfElKq8Wip4SfNQCZ5ysaEPCd5XhR7v85gCoAUuwBaK1hA2QJq8Q0IU6S9YHDdFDqtpRNmCxvdddC4DaPW6mFb9qHl9lRDW7gDdUPlPb0I5nig%2B1268ApEy%2BPJWYqKorEYwZVTpocVIoeElFZrFyI1liBn76IvYd%2FLH%2BptMAud%2B8%2BGsj6NZ3LhlXn75Gfz%2BthV3QN2%2BaKyxwvjsG6KDliu1XvvbXwauHBQG9rMyuCf2zPulPRZ5sP7gWJ3sA7GFcIBj6AVODv5ElSjV9M2HVbOI%2BIr0yOj%2BNbtre9ihw%2FQkZguzv9qq%2B9LDj8%3D
            if(apID !== null && apID !== undefined) {
                let url = new URL(link);
                url.searchParams.set("_apID", apID);
                link = url.toString();
            }
            if(iframe !== null && iframe !== undefined) {
                if (newHeight && iframe.style.height) {
                    iframe.style.height = newHeight + "px";
                }
                iframe.src = link;
            } else {
                if (newHeight && editor.currentIframe.style.height) {
                    editor.currentIframe.style.height = newHeight + "px";
                }
                editor.currentIframe.src = link;
            }
            
            //editor.html.insert('<a href="' + link + '" target="_blank" id="fr-inserted-iframe" class="fr-diagram">' + 'bla' + '</a>'); // Get the file.

            var $iframe = editor.$el.find('#fr-updated-iframe');
            $iframe.removeAttr('id');
            _hideModal();
            editor.undo.saveStep();


            editor.events.trigger('iframe.updated', [$iframe]);
        }

        function remove() {
            let link = get();
            // console.log(link);
            if (editor.events.trigger('drawio.beforeRemove', [link]) === false) return false;

            if (link) {
                editor.selection.save();
                link.parentElement.removeChild(link);
                editor.selection.restore();

                _hideEditPopup();
            }
        }

        function _uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        return {
            _init: _init,
            _showModal: _showModal,
            get: get,
            remove: remove,
            _uuidv4: _uuidv4,
        };
    };

    FE.DefineIcon('insertDrawio', {
        NAME: 'project-diagram',
        template: 'font_awesome_5'
    });
    FE.RegisterShortcut(FE.KEYCODE.D, 'insertDrawio', null, 'D');
    FE.RegisterCommand('insertDrawio', {
        title: 'Insert diagram',
        undo: false,
        focus: true,
        refreshOnCallback: false,
        popup: false,
        callback: function callback() {
            this.drawio._showModal();
        },
        plugin: 'drawio'
    });

    // Define a button.
    FE.RegisterQuickInsertButton('insertDrawio', {
        // Icon name.
        icon: 'insertDrawio',

        // Tooltip.
        title: 'Insert diagram',
        // focus: true,
        // refreshOnCallback: false,
        // popup: false,

        // Callback for the button.
        callback: function () {
            this.drawio._showModal();
        },

        // Save changes to undo stack.
        undo: false
    });


    FE.DefineIcon('drawioOpen', {
        NAME: 'external-link',
        FA5NAME: 'external-link-alt',
        SVG_KEY: 'openLink'
    });
    FE.RegisterCommand('drawioOpen', {
        title: 'Open diagram',
        undo: false,
        refresh: function refresh($btn) {
            var iframe = this.drawio.get();

            if (iframe) {
                $btn.removeClass('fr-hidden');
            } else {
                $btn.addClass('fr-hidden');
            }
        },
        callback: function callback() {
            var iframe = this.drawio.get();
            
            if (iframe) {
                this.o_win.open(iframe.src, '_blank', 'noopener');
                this.popups.hide('drawio.edit');
            }
        },
        plugin: 'drawio'
    });
    FE.DefineIcon('drawioEdit', {
        NAME: 'edit',
        SVG_KEY: 'editLink'
    });
    FE.RegisterCommand('drawioEdit', {
        title: 'Edit diagram',
        undo: false,
        refreshAfterCallback: false,
        popup: false,
        callback: function callback() {
            var iframe = this.drawio.get();
            // console.log(iframe);
            var url = new URL(iframe.src);
            let apID = url.searchParams.get("_apID");
            if(!apID) {
                apID = this.drawio._uuidv4();
                url.searchParams.set("_apID", apID);
                // console.log("random", apID);
                // console.log("url", url.toString());
                iframe.src = url.toString();
            }
            if(iframe.src.indexOf("#R") > -1) {
                this.drawio._showModal(iframe.src.substr(iframe.src.indexOf("#R") + 2), apID);
            }
        },
        refresh: function refresh($btn) {
            var iframe = this.drawio.get();

            if (iframe) {
                $btn.removeClass('fr-hidden');
            } else {
                $btn.addClass('fr-hidden');
            }
        },
        plugin: 'drawio'
    });
    FE.DefineIcon('drawioRemove', {
        NAME: 'remove',
        SVG_KEY: 'remove'
    });
    FE.RegisterCommand('drawioRemove', {
        title: 'Remove',
        callback: function callback() {
            this.drawio.remove();
        },
        refresh: function refresh($btn) {
            var iframe = this.drawio.get();

            if (iframe) {
                $btn.removeClass('fr-hidden');
            } else {
                $btn.addClass('fr-hidden');
            }
        },
        plugin: 'drawio'
    });






})));
//# sourceMappingURL=word_paste.js.map
